import { defineComponent } from 'vue';
import Introduction from '@/presentation/components/introduction/introduction.vue';
import ActiveDashboardsOverview from '@/presentation/components/active-dashboards-overview/active-dashboards-overview.vue';
import InactiveDashboardsOverview from '@/presentation/components/inactive-dashboards-overview/inactive-dashboards-overview.vue';
import HelpAndSupportBlock from '@/presentation/components/help-and-support-block/help-and-support-block.vue';
import DashboardPreviewModal from '@/presentation/components/dashboard-preview-modal/dashboard-preview-modal.vue';
import OverviewCode from '@/presentation/pages/overview/overview.code';

export default defineComponent({
	components: {
		Introduction,
		ActiveDashboardsOverview,
		InactiveDashboardsOverview,
		HelpAndSupportBlock,
		DashboardPreviewModal
	},
	setup: () => {
		const code = new OverviewCode();

		return {
			isDashboardPreviewModalActive: code.isDashboardPreviewModalActive
		};
	}
});
